export default "__VITE_ASSET__DD3W0TfE__"